module.exports = __webpack_public_path__ + "media/images/front/pricing_flow/item-35455a0179507d3cdb0753d515aa9d1d.svg";